import Enum from "./Enum";

export default Enum.create( {
	HIGH: "HIGH",
	MEDIUM: "MEDIUM",
	LOW: "LOW",
} );
